module.exports = __webpack_public_path__ + "img/zhsushe.8498f11b.jpg";